const translations = {
  en: {
    welcome: "Welcome!",
    startMatching: "Start matching",
    startMatchingDone: "Matching complete!",
    startMatchingError: "Matching error. Try again later.",
    searching: "Searching...",
    resetting: "Resetting...",
    myMatches: "My Matches",
    noMatches: "No matches found yet",
    noMatchesDesc: "Start matching to find potential connections",
    reason: "Why we matched:",
    viewProfile: "View Profile",
    startChat: "Start Chat",
    send: "Send",
    typeMessage: "Type your message...",
    logout: "Log out",
    profile: "Profile",
    chat: "Chat",
    dialogs: "Dialogs",
    yourDialogs: "Your dialogs",
    aiGreeting: "Hi! I will help you create a dating profile. Let's start with your name.",
    aiChatTitle: "AI Assistant Chat",
    fillProfile: "Fill profile",
    resetProfileBtn: "Refill profile",
    loading: "Loading...",
    toAI: "To AI",
    toChat: "To chat",
    home: "Home",
    noDialogs: "No chats",
    chooseChat: "Select a chat on the left",
    you: "You",
    // AuthPage:
    login: "Sign In",
    register: "Sign Up",
    login_link: "Sign In",
    register_link: "Sign Up",
    email: "E-mail",
    password: "Password",
    name: "Name",
    error: "Error",
    registrationSuccess: "Registration successful! Please sign in.",
    // Theme/lang
    language: "Language",
    theme: "Theme",
    dark: "Dark",
    light: "Light",
    // Special
    resetProfile: "Change my profile",
    // Invitations
    invitations: "Invitations",
    generateInvite: "Generate Invite",
    myInvitations: "My Invitations",
    inviteCode: "Invite Code",
    enterInviteCode: "Enter invite code",
    invalidInviteCode: "Invalid invite code",
    inviteCodeRequired: "Invite code is required to register",
    inviteStats: "Invitation Statistics",
    totalInvites: "Total Invites",
    usedInvites: "Used Invites",
    activeInvites: "Active Invites",
    copyLink: "Copy Link",
    downloadQR: "Download QR",
    shareInvite: "Share Invitation",
    inviteExpires: "Expires",
    inviteUsed: "Used",
    inviteActive: "Active",
    // QR Code
    myQRCode: "My QR Code",
    permanentQRCode: "Your Permanent QR Code",
    qrCodeDescription: "This is your permanent and unique QR code that others can scan to register using your invitation.",
    regenerateQR: "Regenerate QR Code",
    qrCodeLoading: "Loading QR code...",
    qrCodeError: "Failed to load QR code",
    qrCodeRegenerated: "QR code has been regenerated",
    noInvites: "No invitations yet",
    createFirstInvite: "Create your first invitation",
  },
  fr: {
    welcome: "Bienvenue !",
    startMatching: "Commencer la mise en relation",
    startMatchingDone: "Mise en relation terminée !",
    startMatchingError: "Erreur de mise en relation. Réessayez plus tard.",
    searching: "Recherche...",
    resetting: "Réinitialisation...",
    myMatches: "Mes correspondances",
    noMatches: "Aucune correspondance trouvée pour le moment",
    noMatchesDesc: "Commencez la mise en relation pour trouver des connexions potentielles",
    reason: "Pourquoi nous avons été mis en relation :",
    viewProfile: "Voir le profil",
    startChat: "Commencer la discussion",
    send: "Envoyer",
    typeMessage: "Tapez votre message...",
    logout: "Se déconnecter",
    profile: "Profil",
    chat: "Discussion",
    dialogs: "Dialogues",
    yourDialogs: "Vos dialogues",
    aiGreeting: "Salut ! Je vais vous aider à créer un profil de rencontre. Commençons par votre nom.",
    aiChatTitle: "Chat avec l'Assistant IA",
    fillProfile: "Remplir le profil",
    resetProfileBtn: "Recommencer le profil",
    loading: "Chargement...",
    toAI: "À l'IA",
    toChat: "À la discussion",
    home: "Accueil",
    noDialogs: "Pas de discussions",
    chooseChat: "Sélectionnez un chat à gauche",
    you: "Vous",
    // AuthPage:
    login: "Connexion",
    register: "Inscription",
    login_link: "Connexion",
    register_link: "Inscription",
    email: "E-mail",
    password: "Mot de passe",
    name: "Nom",
    error: "Erreur",
    registrationSuccess: "Inscription réussie ! Veuillez vous connecter.",
    // Theme/lang
    language: "Langue",
    theme: "Thème",
    dark: "Sombre",
    light: "Clair",
    // Special
    resetProfile: "Je veux changer mon profil",
    // Invitations
    invitations: "Invitations",
    generateInvite: "Générer une invitation",
    myInvitations: "Mes invitations",
    inviteCode: "Code d'invitation",
    enterInviteCode: "Entrez le code d'invitation",
    invalidInviteCode: "Code d'invitation invalide",
    inviteCodeRequired: "Un code d'invitation est requis pour s'inscrire",
    inviteStats: "Statistiques d'invitation",
    totalInvites: "Total des invitations",
    usedInvites: "Invitations utilisées",
    activeInvites: "Invitations actives",
    copyLink: "Copier le lien",
    downloadQR: "Télécharger QR",
    shareInvite: "Partager l'invitation",
    inviteExpires: "Expire",
    inviteUsed: "Utilisé",
    inviteActive: "Actif",
    // QR Code
    myQRCode: "Mon Code QR",
    permanentQRCode: "Votre Code QR Permanent",
    qrCodeDescription: "Partagez ce QR code unique pour inviter vos contacts à rejoindre la plateforme. Il est permanent et lié à  votre compte.",
    regenerateQR: "Régénérer le Code QR",
    qrCodeLoading: "Chargement du code QR...",
    qrCodeError: "Échec du chargement du code QR",
    qrCodeRegenerated: "Le code QR a été régénéré",
    noInvites: "Aucune invitation pour le moment",
    createFirstInvite: "Créez votre première invitation",
  },
  ru: {
    welcome: "Добро пожаловать!",
    startMatching: "Начать поиск",
    startMatchingDone: "Поиск завершен!",
    startMatchingError: "Ошибка поиска. Попробуйте позже.",
    searching: "Поиск...",
    resetting: "Сброс...",
    myMatches: "Мои совпадения",
    noMatches: "Совпадений пока нет",
    noMatchesDesc: "Начните поиск, чтобы найти потенциальные связи",
    reason: "Почему мы подошли:",
    viewProfile: "Посмотреть профиль",
    startChat: "Начать чат",
    send: "Отправить",
    typeMessage: "Введите сообщение...",
    logout: "Выйти",
    profile: "Профиль",
    chat: "Чат",
    dialogs: "Диалоги",
    yourDialogs: "Ваши диалоги",
    aiGreeting: "Привет! Я помогу создать профиль для знакомств. Начнем с вашего имени.",
    aiChatTitle: "Чат с ИИ-ассистентом",
    fillProfile: "Заполнить профиль",
    resetProfileBtn: "Перезаполнить профиль",
    loading: "Загрузка...",
    toAI: "К ИИ",
    toChat: "К чату",
    home: "Главная",
    noDialogs: "Нет чатов",
    chooseChat: "Выберите чат слева",
    you: "Вы",
    // AuthPage:
    login: "Войти",
    register: "Регистрация",
    login_link: "Войти",
    register_link: "Регистрация",
    email: "E-mail",
    password: "Пароль",
    name: "Имя",
    error: "Ошибка",
    registrationSuccess: "Регистрация успешна! Пожалуйста, войдите в систему.",
    // Theme/lang
    language: "Язык",
    theme: "Тема",
    dark: "Темная",
    light: "Светлая",
    // Special
    resetProfile: "Я хочу изменить свой профиль",
    // Invitations
    invitations: "Приглашения",
    generateInvite: "Создать приглашение",
    myInvitations: "Мои приглашения",
    inviteCode: "Код приглашения",
    enterInviteCode: "Введите код приглашения",
    invalidInviteCode: "Неверный код приглашения",
    inviteCodeRequired: "Для регистрации необходим код приглашения",
    inviteStats: "Статистика приглашений",
    totalInvites: "Всего приглашений",
    usedInvites: "Использовано",
    activeInvites: "Активные",
    copyLink: "Копировать ссылку",
    downloadQR: "Скачать QR",
    shareInvite: "Поделиться приглашением",
    inviteExpires: "Истекает",
    inviteUsed: "Использовано",
    inviteActive: "Активно",
    // QR Code
    myQRCode: "Мой QR Код",
    permanentQRCode: "Ваш Постоянный QR Код",
    qrCodeDescription: "Это ваш персональный QR код, который другие могут отсканировать для регистрации по вашему приглашению. Он постоянный и уникальный для вашего аккаунта.",
    regenerateQR: "Обновить QR Код",
    qrCodeLoading: "Загрузка QR кода...",
    qrCodeError: "Не удалось загрузить QR код",
    qrCodeRegenerated: "QR код был обновлен",
    noInvites: "Пока нет приглашений",
    createFirstInvite: "Создайте ваше первое приглашение",
    
  }
  
};

export default translations;
